(function ($) {

    $(document).ready(function () {

        var gallery = $('.hp-gallery-row, .pv-gallery-row');

        gallery.each(function () {
            var _this = $(this);
            var _div = $('<div class="content"></div>');
            var _target = _this.find('.wp-block-column').not('.gallery');
            _target.children().wrapAll(_div);
        });

        if (gallery.length) {

            $('.wp-block-gallery').slick({
                dots: true,
                arrows: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true
            });
        }

    });

})(jQuery);
